<template>
	<div class="wxpro">
		<div class="con">
			<div class="proImg"><img alt="" src="https://img.alicdn.com/bao/uploaded/i4/2986333609/O1CN01j2Yoxx1cWxw06CnZK_!!0-item_pic.jpg" /></div>
		</div>
		<div class="container">
			<div class="clear">
				<div class="con_pro">
					<div class="proname">魔术贴厚底凉鞋女夏2019韩版新款小熊鞋底时尚百搭运动学生沙滩鞋</div>
					<div class="price_box">
						<div class="price">
							<div class="price_after">
								￥
								<span class="strongF">29.9</span>
								<span class="price_before">￥169.9</span>
							</div>
						</div>
					</div>
				</div>
				<div class="coupon">
					<span>￥</span>
					140
				</div>
			</div>
		</div>
		<div class="fixbox" @click="maskView">去购买</div>

		<div class="mask" v-if="mask">
			<div class="copy_con">
				<div class="ewm">{{ tpwd }}</div>
				<div class="btn" @click="copy" id="buttoncopy"><button :data-clipboard-text="tpwd">复制</button></div>
				<div class="close_btn" @click="maskView"></div>
			</div>
		</div>
	</div>
</template>

<script>
import ClipboardJS from 'clipboard';
export default {
	data() {
		return {
			tpwd: '￥prreYTTfPjx￥',
			mask: false
		};
	},
	created() {
		var params = this.$route.query;
		if(!params.tkl){
			suni.showToast({
				title: '商品不存在'
			});
			return ;
			
		}
		this.tkl = '￥'+params['tkl']+'￥';
		console.log(params);
	},
	methods: {
		maskView() {
			this.mask = !this.mask;
		},
		copy() {
			var tpwd = this.tpwd;
			var clipboard = new ClipboardJS('#buttoncopy', {
				text: function(trigger) {
					console.log(trigger);
					return tpwd;
				}
			});

			clipboard.on('success', function(e) {
				console.info('Action:', e.action);
				console.info('Text:', e.text);
				console.info('Trigger:', e.trigger);
				suni.showToast({
					title: '复制成功！'
				});
				clipboard.destroy();
			});

			clipboard.on('error', function(e) {
				console.error('Action:', e.action);
				console.error('Trigger:', e.trigger);
				suni.showToast({
					title: '复制失败'
				});
				clipboard.destroy();
			});
		}
	}
};
</script>

<style>
html,
body,
.wxpro {
	height: 100%;
	background: #FFFFFF;
}
.wxpro {
	position: relative;
}

.proImg img {
	width: 100%;
}
.container {
	padding: 0 10px;
	position: relative;
}
.actContainer {
	height: 100%;
}
.proname {
	line-height: 1.5;
	font-size: 18px;
	color: #000;
}
.price_after {
	color: #fb3e3e;
	font-size: 18px;
	line-height: 1.6;
}
.price_after .strongF {
	font-size: 22px;
}
.price_after span {
	font-size: 18px;
}
.price_box {
	overflow: hidden;
	margin-top: 10px;
}
.price_box .price {
	float: left;
}
.price_before {
	color: #bebebe;
	font-size: 18px !important;
	text-decoration: line-through;
	padding-left: 10px;
}
.con_pro {
	float: left;
	width: 70%;
}
.coupon {
	float: right;
	width: 25%;
	height: 43px;
	line-height: 43px;
	color: #fff;
	font-size: 18px;
	background: url(http://xiaoluluoo.cn/html5/static/img/youhuiquan.d73bc21.png) no-repeat;
	-webkit-background-size: 100% 100%;
	background-size: 100%;
	padding-left: 10px;
	text-align: left;
	float: right;
}
.clear {
	clear: both;
	overflow: hidden;
}
.con {
	overflow: auto;
}
.clipboard {
	margin-top: 1.5rem;
	margin-bottom: 3rem;
}
.clipboard .top {
	border: 1px dashed #fb6028;
	border-radius: 0.2rem 0.2rem 0 0;
	background-color: #fff1ee;
	text-align: center;
	font-size: 0.75rem;
	line-height: 1.125rem;
	height: 3.125rem;
	padding-top: 0.6rem;
	-webkit-user-select: text;
	-moz-user-select: text;
	-ms-user-select: text;
	user-select: text;
}
.clipboard .top p {
	font-size: 0.6rem;
}
.clipboard .bot {
	text-align: center;
	color: #fff;
	background: -webkit-gradient(linear, 0 50%, 100% 50%, from(#f8b931), to(#fe8507));
	background: -webkit-linear-gradient(left, #f8b931, #fe8507);
	height: 1.875rem;
	line-height: 1.875rem;
	font-size: 0.7rem;
	border-radius: 0 0 0.2rem 0.2rem;
}
.clipboard .bot button {
	border: 0px;
	background: -webkit-gradient(linear, 0 50%, 100% 50%, from(#f8b931), to(#fe8507));
	background: -webkit-linear-gradient(left, #f8b931, #fe8507);
	color: #fff;
	width: 100%;
}
.clipboard i {
	display: inline-block;
	height: 0.75rem;
}
.clipboard i img {
	height: 100%;
}
.nopro {
	position: absolute;
	top: 50%;
	left: 5%;
	width: 90%;
	margin-top: -2.5rem;
}
.fixbox {
	position: fixed;
	margin: 0 auto;
	margin-left: 10%;
	width: 80%;
	height: 50px;
	line-height: 50px;
	border-radius: 30px;
	background-color: #fb3e3e;
	text-align: center;
	bottom: 20px;
	color: #fff;
	font-size: 22px;
}
i {
	display: inline-block;
	height: 0.75rem;
}
i img {
	height: 100%;
}
.copy_con {
	width: 80%;

	background-color: #fff;
	border-radius: 10px;
	margin: 36px auto;
}
.mask {
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 1000;
	background: rgba(0, 0, 0, 0.7);
}

.mask .copy_con {
	position: relative;
	z-index: 9999;
	padding-bottom: 10px;
}
.mask .ewm {
	width: 70%;
	height: 120px;
	background: url(http://xiaoluluoo.cn/html5/static/img/taokoulin.be1b3f1.png) no-repeat center 2rem;
	-webkit-background-size: 100% 100%;
	background-size: 100%;
	margin: 10px auto;
	padding-top: 45px;
	text-align: center;
	line-height: 100px;
	font-size: 25px;
}
.mask .btn {
	width: 80%;
	height: 40px;
	line-height: 40px;
	border-radius: 10px;
	background-color: #fb3e3e;
	color: #fff;
	font-size: 18px;
	text-align: center;
	margin: 0 auto;
	margin-bottom: 20px;
}
.mask .btn button {
	color: #fff;
	font-size: 18px;
	-webkit-appearance: none;
	background: none;
	border: 0px;
}
.mask .close_btn {
	width: 1.25rem;
	height: 2.25rem;
	background: url(http://xiaoluluoo.cn/html5/static/img/line_close.cce8af3.png);
	-webkit-background-size: 100% 100%;
	background-size: 100% 100%;
	position: absolute;
	left: 50%;
	bottom: -2.25rem;
	z-index: 99;
	margin-left: -0.625rem;
}
</style>
